import { ColDef } from 'ag-grid-community'
import { AgGridReact, AgGridReactProps } from 'ag-grid-react'
import clsx from 'clsx'
import { CSSProperties, forwardRef, MutableRefObject } from 'react'

import classes from './table.module.scss'

export const COMMON_DEFAULT_COLUMN_OPTIONS: ColDef = {
  sortable: true,
  unSortIcon: true
}

const NoRows = () => <p className={classes.noRows}>No results</p>

interface Props {
  agGridProps: AgGridReactProps
  className?: string
  height?: string
  showGreyHeader?: boolean
  width?: string
}
export const Table = forwardRef(
  (
    { agGridProps, className, height, showGreyHeader, width, ...props }: Props,
    ref: MutableRefObject<any>
  ) => {
    const styles: CSSProperties = {}
    if (height) {
      styles.height = height
      styles.maxHeight = height
    }
    if (width) {
      styles.width = '100%'
      styles.maxWidth = width
    }
    return (
      <div
        className={clsx(classes.tableWrapper, 'ag-theme-alpine', className, {
          [classes.greyHeader]: showGreyHeader
        })}
        style={styles}
        {...props}
      >
        <AgGridReact noRowsOverlayComponent={NoRows} {...agGridProps} ref={ref} />
      </div>
    )
  }
)
